import clsx from 'clsx'
import type { ReactNode } from 'react'
import type { Icon } from '../../types/ui'

type ButtonProps = {
  children: ReactNode
  className?: string
  icon?: Icon
  onClick?: () => void
  variant?: 'primary' | 'soft' | 'ghost' | 'danger'
  type?: 'button' | 'submit'
  disabled?: boolean
}

export function Button({
  children,
  className,
  icon: IconNode,
  onClick,
  variant = 'primary',
  type = 'button',
  disabled = false,
}: ButtonProps) {
  return (
    <button
      className={clsx(
        'inline-flex min-h-10 items-center justify-center gap-2 rounded-lg px-4 text-sm font-semibold transition focus:outline-none focus:ring-4 focus:ring-mango-yellow/30',
        variant === 'primary' && 'bg-mango-orange text-white shadow-sm hover:bg-[#d98509]',
        variant === 'soft' && 'bg-mango-yellow/20 text-leaf-dark hover:bg-mango-yellow/35',
        variant === 'ghost' && 'text-stone-600 hover:bg-stone-100',
        variant === 'danger' && 'bg-red-600 text-white hover:bg-red-700',
        disabled && 'cursor-not-allowed opacity-60',
        className,
      )}
      disabled={disabled}
      onClick={onClick}
      type={type}
    >
      {IconNode ? <IconNode className="h-4 w-4" /> : null}
      {children}
    </button>
  )
}
